// Visitor side of talking NPCs: which talking NPC you're standing next to,
// which one you're talking to, and where each NPC's body is right now
// (wandering NPCs move, so the 3D body is the source of truth).
import { create } from 'zustand';
import type * as THREE from 'three';

interface NpcTalkState {
  /** Primitive id of the nearest talking NPC within reach, or null. */
  near: string | null;
  /** Distance to `near` in metres (for voice volume). */
  nearDist: number;
  /** The NPC whose chat panel is open. It stops and faces you. */
  talkingTo: string | null;
  /** NPCs currently speaking (mouth/arms could follow this later). */
  speaking: string | null;
  setNear: (id: string | null, dist: number) => void;
  setTalkingTo: (id: string | null) => void;
  setSpeaking: (id: string | null) => void;
}

export const useNpcTalk = create<NpcTalkState>((set) => ({
  near: null,
  nearDist: Infinity,
  talkingTo: null,
  speaking: null,
  setNear: (near, nearDist) => set((s) => (s.near === near && Math.abs(s.nearDist - nearDist) < 0.25 ? s : { near, nearDist })),
  setTalkingTo: (talkingTo) => set({ talkingTo }),
  setSpeaking: (speaking) => set({ speaking }),
}));

/** NPC bodies by primitive id, registered by NpcModel while mounted. */
export const npcBodies = new Map<string, THREE.Object3D>();

/** Reach for the "Talk" prompt, and how far the chat stays open if you walk off. */
export const TALK_REACH = 3;
export const TALK_KEEP = 7;

if (import.meta.env.DEV) (window as any).__gathrxrNpcTalk = useNpcTalk;
